import { api } from '../lib/api';
import type { Comment } from '../types';

export async function addComment(
  itemId: string,
  _userId: string,
  text: string,
): Promise<string> {
  const res = await api<{ id: string }>(`/api/items/${itemId}/comments`, {
    method: 'POST',
    body: JSON.stringify({ text }),
  });
  return res.id;
}

export async function getComments(itemId: string): Promise<Comment[]> {
  const results = await api<any[]>(`/api/items/${itemId}/comments`);
  return results.map((r) => ({
    id: r.id,
    text: r.text ?? '',
    createdBy: r.createdBy,
    createdAt: new Date(r.createdAt),
  }));
}

export async function deleteComment(_itemId: string, commentId: string): Promise<void> {
  await api(`/api/comments/${commentId}`, { method: 'DELETE' });
}
